"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _Spinner = _interopRequireDefault(require("@cimpress/react-components/lib/shapes/Spinner"));

var _emotion = require("emotion");

var _react = _interopRequireWildcard(require("react"));

var _revisionOption = _interopRequireDefault(require("../revisionOption"));

var statuses = _interopRequireWildcard(require("./entityStatus"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  font-size: 1.214em;\n  justify-content: center;\n  text-align: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-bottom: 5px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _emotion.css)(_templateObject());
var centerStyle = (0, _emotion.css)(_templateObject2(), colors.slate);

var RevisionSelectorOptionList =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(RevisionSelectorOptionList, _PureComponent);

  function RevisionSelectorOptionList() {
    (0, _classCallCheck2.default)(this, RevisionSelectorOptionList);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RevisionSelectorOptionList).apply(this, arguments));
  }

  (0, _createClass2.default)(RevisionSelectorOptionList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          priceModelId = _this$props.priceModelId,
          revisionId = _this$props.revisionId,
          revisions = _this$props.revisions,
          revisionStatus = _this$props.revisionStatus,
          onSelect = _this$props.onSelect,
          errorMessage = _this$props.errorMessage;
      var finalClassName = (0, _emotion.cx)(style, className);

      if (revisionStatus === statuses.LOADING || revisionStatus === statuses.NOT_LOADED) {
        return _react.default.createElement("div", {
          className: (0, _emotion.cx)(centerStyle, style, className)
        }, _react.default.createElement(_Spinner.default, null));
      }

      if (revisionStatus === statuses.UNAVAILABLE) {
        return _react.default.createElement("div", {
          className: (0, _emotion.cx)(centerStyle, style, className)
        }, "Failed to load price models. Please try again. For support, please contact FinancialFlowsSupport@cimpress.com");
      }

      if (!revisions || !revisions.length) {
        return _react.default.createElement("div", {
          className: (0, _emotion.cx)(centerStyle, style, className)
        }, _react.default.createElement("div", null, errorMessage || "It looks like you don't have prices set up for this combination of products"));
      }

      var revisionOptions = revisions.map(function (revision) {
        var key = "".concat(revision.id, "-").concat(revision.revisionId);
        var selected = priceModelId === revision.id && revisionId === revision.revisionId;
        return _react.default.createElement(_revisionOption.default, {
          key: key,
          name: revision.name,
          priceModelId: revision.id,
          revisionId: revision.revisionId,
          selected: selected,
          onSelect: onSelect
        });
      });
      return _react.default.createElement("div", {
        className: finalClassName
      }, revisionOptions);
    }
  }]);
  return RevisionSelectorOptionList;
}(_react.PureComponent);

var _default = RevisionSelectorOptionList;
exports.default = _default;